<template>
  <div class="col-sm-12 col-lg-8 pd-5">
    <div class="card p-1 mb-0">
      <div class="d-flex justify-content-between align-items-center px-1 py-1">
        <div class="btn-group">
          <button
            class="btn btn-sm"
            :class="activeTab === 'collection' ? 'btn-primary' : 'btn-outline-primary'"
            @click="activeTab = 'collection'"
          >
            Collection
          </button>
          <button
            class="btn btn-sm"
            :class="activeTab === 'patients' ? 'btn-primary' : 'btn-outline-primary'"
            @click="activeTab = 'patients'"
          >
            Patients
          </button>
        </div>

        <select
          @change="$emit('onDateChange', statisticsItem[itemKey])"
          v-model="statisticsItem[itemKey].period_type"
          class="form-control form-control-sm width-150"
          style="padding: 0; border: none; text-align: right"
        >
          <option value="" disabled selected>Select Range</option>
          <option
            v-for="(range, j) in timeRange.slice(0, 2)"
            :key="j"
            :value="range.value"
          >
            {{ range.name }}
          </option>
        </select>
      </div>
      <BarChart
        :chartData="{
          labels: statisticsItem[itemKey].data.labels,
          datasets: statisticsItem[itemKey].data.data[activeTab]
        }"
        :chartOptions="options"
        :height="120"
      />
    </div>
  </div>
</template>

<script setup>
import BarChart from '@/components/atom/chart/barChart'
import { ref } from 'vue'

defineProps({
  statisticsItem: Object,
  page: Object,
  itemKey: String,
  timeRange: Array
})

const activeTab = ref('collection')
const options = {
  plugins: {
    legend: {
      display: false
    }
  },
}
</script>
